import { cxApiClient, consumerApiClient } from '@shared/api/clients/apiClientFactory';
import { ApiEndpoints } from '@shared/api/api-endpoints';
import { transformJsonToObject } from '@shared/utils/jsonToObjectTransformer';
import { ReconnectRequestPayload, ReconnectResponse, TimeSlotChoice } from'./types';

export const createReconnectRequest = async (data: ReconnectRequestPayload): Promise<ReconnectResponse> => {
 return new Promise((resolve) => {
 setTimeout(() => {
  resolve({ id:'REC-'+ Math.floor(Math.random() * 1000), status:'Pending'});
 }, 1000);
 });
};

export const getTimeSlotChoices = async (): Promise<{ result: TimeSlotChoice[] }> => {
  const url = ApiEndpoints.createUrl("consumerWeb", "choices/time_slot");
  const response = await cxApiClient.get(url);
  return transformJsonToObject<{ result: TimeSlotChoice[] }>(response.data);
};

export const createReconnectionWithPayment = async (data: any): Promise<any> => {
  const url = ApiEndpoints.createUrlWithPathVariables("consumerWeb", "connection-status-request");
  const response = await consumerApiClient.post(url, data);
  return response.data;
};

export const createBulkReconnectRequest = async (data: any): Promise<any> => {
  const url = ApiEndpoints.createUrlWithPathVariables("consumerWeb", "bulk-requests");
  const response = await cxApiClient.post(url, data);
  return response.data;
};

export const searchMasterConsumers = async (params: { remoteUtilityId: number; searchData: string }): Promise<any> => {
  const url = ApiEndpoints.createUrlWithPathVariables("consumerWeb", "consumer-search/info");
  const response = await consumerApiClient.get(url, {
    params: {
      remote_utility_id: params.remoteUtilityId,
      search_data: params.searchData,
      is_master_consumer: 1,
    }
  });
  return response.data;
};
